import { PartListPage } from 'parts/pages';

import { partListPath } from './routePaths';

export const parts = {
  path: partListPath(),
  exact: true,
  element: <PartListPage />,
};
